"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./_commonjsHelpers.js"),r=require("../utils/string/getInitials.js"),s=e.getAugmentedNamespace(r);exports.default=s;
